import { IDIService } from "../IDIService";

interface IAndroidLocationService  extends IDIService {
	CheckLocationPermissionAsync(): Promise<boolean>;
	RequestLocationPermissionAsync(): Promise<boolean>;
	IsAndroidLocationAvailable(): boolean;
}

export class AndroidLocationService implements IAndroidLocationService
{
	public static readonly ServiceName: string = "AndroidLocationService";

	CheckLocationPermissionAsync(): Promise<boolean> {
		if (this.IsAndroidLocationAvailable()) {
			return (navigator as any).AndroidLocation.CheckLocationPermissionAsync();
		}
		return Promise.resolve(false);
	}

	RequestLocationPermissionAsync(): Promise<boolean> {
		if(this.IsAndroidLocationAvailable()) {
			return (navigator as any).AndroidLocation.RequestLocationPermissionAsync();
		}
		return Promise.resolve(false);
	}

	IsAndroidLocationAvailable(): boolean {
		return (navigator as any).AndroidLocation !== undefined;
	}

	GetServiceName(): string {
		return AndroidLocationService.ServiceName;
	}
	
}